import type { Lang } from '@bookingdei/i18n/translate';
import { interpolate } from '@bookingdei/i18n/interpolate';
import { brand, company, region } from '../theme/tokens';

// Messages in packages/i18n are tenant-blind (INF-1): they carry `{brand}` and
// `{region}` placeholders instead of the literals, which live only in theme/.
// Every string resolved through the language context passes through here, so a
// screen never has to remember to substitute. Strings without a placeholder are
// returned untouched.
// Message-local variables, e.g. `{count}` in 'offers.results_count'. Numbers are
// rendered in the active language's numerals — Bangla mode shows ৩, not 3 — because
// §12 requires numerals to switch with the language, and a screen that formatted them
// itself would be one more place to forget.
export type MessageVars = Record<string, string | number>;

export function fillTokens(text: string, lang: Lang, vars?: MessageVars): string {
  if (!text.includes('{')) return text;
  const out = text
    .replaceAll('{brand}', brand.name)
    .replaceAll('{company_short}', company.short)
    .replaceAll('{company}', company.name)
    .replaceAll('{region}', lang === 'bn' ? region.bn : region.en);
  // Vars (including ICU-lite plurals such as `{n, plural, one{# service} other{…}}`)
  // go through the shared i18n interpolator, which localises numerals.
  return vars ? interpolate(lang, out, vars) : out;
}
